import { z } from 'zod';

const lookupSelectionSchema = z.object({
    id: z.string(),
    name: z.string().optional(),
});

export const SuperAdminBookingsPageFilterFormSchema = z.object({
    startDate: z.date().nullable(),
    endDate: z.date().nullable(),
    tenant: z.array(lookupSelectionSchema),
    hotel: z.array(lookupSelectionSchema),
    owner: z.array(lookupSelectionSchema),
    apartment: z.array(lookupSelectionSchema),
    documentNumber: z.string().nullable(),
});

export type SuperAdminBookingsPageFilterFormData = z.infer<
    typeof SuperAdminBookingsPageFilterFormSchema
>;
